/**
 * Returns the given value only if it is an http(s) absolute URL, otherwise undefined.
 *
 * Guards against `javascript:` (and other) URI XSS when untrusted values are
 * placed into an anchor `href`. React does not sanitize `href`, so a value like
 * `javascript:...` would execute on click. Callers should treat `undefined` as
 * "not a safe link" and render non-clickable content instead.
 */
export function safeHttpUrl(value?: string | null): string | undefined {
  if (!value) {
    return undefined;
  }

  return /^https?:\/\//i.test(value) ? value : undefined;
}
